import React from 'react'
import {Lang} from 'yougile-lang'
import {Notifications} from '@components/account/notifications'
import {PageComponent} from '@components/page/page-component'
import {SimplePageTitle} from '@components/page/simple-page-title'
import {useSyncEventUpdateEffect} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {Companies} from './companies/companies'
import {DownloadApp} from './download-app/download-app'
import {DownloadMobileApp} from './download-mobile-app/download-mobile-app'
import {Panel} from './panel'
import {Profile} from './profile/profile'
import {SystemAppearance} from './system-appearance/system-appearance'

export const AccountPage = () => {
  useSyncEventUpdateEffect('profile', {
    debounceTime: 50,
    filter: globals.currentUserId
  })
  const title = <SimplePageTitle title={Lang.msg.settings} />
  return (
    <PageComponent title={title} topZero scrollable>
      <div className="flex flex-col h-full" style={{minWidth: 680}}>
        <div className="mr-16 max-w-1090 mt-85">
          <div className="flex flex-wrap gap-16">
            <Panel title={Lang.msg.profile} logout>
              <Profile />
            </Panel>
            <div className="flex flex-col gap-16 flex-1">
              <DownloadMobileApp />
              <Panel title={Lang.msg.profilePage.downloadDesktop}>
                <DownloadApp />
              </Panel>
            </div>
          </div>
          <div className="mt-16">
            <Panel title={Lang.msg.profilePage.notifications}>
              <Notifications />
            </Panel>
          </div>
          <div className="mt-16">
            <Panel title={Lang.msg.profilePage.systemAppearance}>
              <SystemAppearance />
            </Panel>
          </div>
          <div className="mt-16 mb-56">
            <Panel title={Lang.msg.companiesList}>
              <Companies />
            </Panel>
          </div>
        </div>
      </div>
    </PageComponent>
  )
}
